import { useState, useRef, useCallback } from 'react';
import { LoaderComponent } from 'components/common';
import NewPptImg from 'assets/images/new-ppt-img.svg';

const CreatePropertyImages = ({
  imgs,
  setImages,
  imgError,
  setImgError,
}: any) => {
  const [loading, setLoading] = useState<boolean>(false);

  const fileInput = useRef<any>(null);

  // TODO:
  // 1. Delete images from cloudinary when property wasn't created
  // 2. Delete images normally and also remove from cloudinary

  function openImageFile() {
    setImgError('');
    if (fileInput.current) fileInput.current.click();
  }

  const EmptyImg = useCallback(
    () => (
      <div
        className="p-auto"
        onClick={openImageFile}
        role="button"
        onKeyDown={openImageFile}
        aria-hidden="true"
      >
        <img src={NewPptImg} alt="" />
      </div>
    ),
    []
  );

  const uploadImageToCloudinary = async (image: any) => {
    const data = new FormData();
    data.append('file', image);
    data.append('upload_preset', 'septagon');
    const currentDate = new Date();
    data.append('api_key', '955177252593857');
    data.append('timestamp', '1315060510');
    setLoading(true);

    let result: any = '';
    await fetch('https://api.cloudinary.com/v1_1/septagon/upload', {
      method: 'post',
      body: data,
    })
      .then((response) => response.json())
      .then((res) => {
        result = res;
      })
      .catch((err) => {
        setImgError('Unable to upload file');
      })
      .then(() => {
        setLoading(false);
      });

    return result;
  };

  const handleFileChange = async (e: any) => {
    setImgError('');
    const file = e.target.files[0];
    if (file.size > 1024000) {
      setImgError('File size cannot exceed more than 100MB');
    } else {
      const uploadedFile = await uploadImageToCloudinary(file);
      const newFile: any = {};
      newFile.url = uploadedFile.secure_url;
      newFile.name = file.name;
      const files = [...imgs];
      files.push(newFile);
      setImages(files);
    }
  };

  function isImgLink(url: any) {
    if (typeof url !== 'string') return false;
    return (
      url.match(/^http[^]*.(jpg|jpeg|gif|png|tiff|bmp)(\?(.*))?$/gim) != null
    );
  }

  const ShowImage = useCallback(({ image }: any) => {
    if (image.url && isImgLink(image.url)) {
      return (
        <div className="w-20 h-20">
          <img className="w-20 h-20" src={image.url} alt={image.name} />{' '}
        </div>
      );
    }
    return <p className="text-white">{image.name}</p>;
  }, []);

  return (
    <div className="">
      {loading ? <LoaderComponent /> : ''}
      <label className="text-white text-lg mb-2">
        Image, Video or 3D Model
      </label>
      <p className="text-white opacity-75 text-xs my-4">
        Supported file type : PNG, JPEG, MP4, WEBM. Max size : 100 MB ( You can
        select multiple files).
      </p>

      <div className="border border-primary-1 grid grid-cols-2 rounded-xl">
        <div className="flex justify-center border border-primary-1 rounded-tl-xl py-12">
          {imgs[0] && imgs[0].name ? (
            <ShowImage image={imgs[0]} />
          ) : (
            <EmptyImg />
          )}
        </div>
        <div className="flex justify-center border border-primary-1 rounded-tr-xl py-12">
          {imgs[1] && imgs[1].name ? (
            <ShowImage image={imgs[1]} />
          ) : (
            <EmptyImg />
          )}
        </div>
        <div className="flex justify-center border border-primary-1 rounded-bl-xl py-12">
          {imgs[2] && imgs[2].name ? (
            <ShowImage image={imgs[2]} />
          ) : (
            <EmptyImg />
          )}
        </div>{' '}
        <div className="flex justify-center border border-primary-1 rounded-br-xl py-12">
          {imgs[3] && imgs[3].name ? (
            <ShowImage image={imgs[3]} />
          ) : (
            <EmptyImg />
          )}
        </div>
      </div>
      <input
        ref={fileInput}
        onChange={(e) => {
          handleFileChange(e);
        }}
        type="file"
        style={{ display: 'none' }}
      />
      {imgError && (
        <p className="text-red-700 text-center text-xs my-4">{imgError}</p>
      )}
    </div>
  );
};

export default CreatePropertyImages;
